import { UtilService } from './../Util/Util';
import { ParentService } from './parent/parent.service';
import { AccountService } from './account/account.service';
import { LivesearchService } from './livesearch/livesearch.service';
import { Injectable } from '@angular/core';
import { StorageService } from './../storage/storage.service';
import axios from 'axios';
import { ShareDataService } from '../share-data/share-data.service';
@Injectable({
  providedIn: 'root'
})
export class RequestService {
  private static parentAPI;
  private static accountAPI;
  private static ecmAPI;
  private static livesearchAPI;

  private env;
  private wsApi;
  private ecmAPI;
  private ecmLiveSearch;
  private instance: any;

  constructor(
    private util: UtilService,
    private storage: StorageService,
    private shareDataService: ShareDataService
  ) {
    this.env = this.util.getEnv();
    this.wsApi = this.env['webservice_api'];
    this.ecmAPI = this.env['ecm_api'];
    this.ecmLiveSearch = this.env['live_search'];

    // this.ecmLiveSearch = 'http://35.240.219.164:196/lib/perform_function.php?d=livesearch&f=movement_address-backend.php';

    
    
  }

  public _axios(url) {
    this.instance = axios.create({
        baseURL: url,
        timeout: 30000,
    });
    return this.instance;
  }

  public getParentAPI(): ParentService {
    if (RequestService.parentAPI == null) {
      RequestService.parentAPI = new ParentService(
        this._axios(this.wsApi),
        this.util,
        this.storage,
        this.shareDataService
      );
    }
    return RequestService.parentAPI;
  }

  public getAccountAPI(): AccountService {
    if (RequestService.accountAPI == null) {
        RequestService.accountAPI = new AccountService(this._axios(this.ecmAPI));
    }
    return RequestService.accountAPI;
  }

  public getLivesearchAPI():LivesearchService {
    if (RequestService.livesearchAPI == null) {
      RequestService.livesearchAPI = new LivesearchService(
        this._axios(this.ecmLiveSearch),
        this.env
      );
    }
    return RequestService.livesearchAPI;
  }
}
